export default __webpack_public_path__ + "static/media/monthly_incomeHelp1.00b4fb15.png";